module.exports = __webpack_public_path__ + "img/LKW_K_Lkr_1_5t.44374769.svg";